export const CODE_REGEX = /^(?=.*[a-zA-Z0-9])[a-zA-Z0-9_-]+$/;
